(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("@material-ui/core/styles"), require("@material-ui/core/Typography"), require("@material-ui/core/FormHelperText"), require("react-phone-input-2"), require("react-phone-input-2/lib/material.css"));
	else if(typeof define === 'function' && define.amd)
		define(["react", "@material-ui/core/styles", "@material-ui/core/Typography", "@material-ui/core/FormHelperText", "react-phone-input-2", "react-phone-input-2/lib/material.css"], factory);
	else if(typeof exports === 'object')
		exports["default"] = factory(require("react"), require("@material-ui/core/styles"), require("@material-ui/core/Typography"), require("@material-ui/core/FormHelperText"), require("react-phone-input-2"), require("react-phone-input-2/lib/material.css"));
	else
		root["default"] = factory(root["react"], root["@material-ui/core/styles"], root["@material-ui/core/Typography"], root["@material-ui/core/FormHelperText"], root["react-phone-input-2"], root["react-phone-input-2/lib/material.css"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__3__, __WEBPACK_EXTERNAL_MODULE__12__, __WEBPACK_EXTERNAL_MODULE__308__, __WEBPACK_EXTERNAL_MODULE__349__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 426);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__12__;

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__3__;

/***/ }),

/***/ 308:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__308__;

/***/ }),

/***/ 349:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__349__;

/***/ }),

/***/ 426:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(0);

// EXTERNAL MODULE: /opt/atlassian/pipelines/agent/build/node_modules/classnames/index.js
var classnames = __webpack_require__(5);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: external "@material-ui/core/styles"
var styles_ = __webpack_require__(1);

// EXTERNAL MODULE: external "@material-ui/core/Typography"
var Typography_ = __webpack_require__(3);
var Typography_default = /*#__PURE__*/__webpack_require__.n(Typography_);

// EXTERNAL MODULE: external "@material-ui/core/FormHelperText"
var FormHelperText_ = __webpack_require__(12);
var FormHelperText_default = /*#__PURE__*/__webpack_require__.n(FormHelperText_);

// EXTERNAL MODULE: external "react-phone-input-2"
var external_react_phone_input_2_ = __webpack_require__(308);
var external_react_phone_input_2_default = /*#__PURE__*/__webpack_require__.n(external_react_phone_input_2_);

// EXTERNAL MODULE: external "react-phone-input-2/lib/material.css"
var material_css_ = __webpack_require__(349);

// CONCATENATED MODULE: ./src/PhoneInput/PhoneInput.jsx
var _excluded = ["classes", "error", "disabled", "fullWidth", "variant", "helperText", "label"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }



 // $FlowFixMe







var styles = function styles(_ref) {
  var extras = _ref.extras,
      palette = _ref.palette;
  return {
    root: {},
    input: {
      '&.form-control': {
        '&+div:before': {
          display: 'none'
        }
      }
    },
    fullWidthInput: {
      '&.form-control.form-control': {
        width: '100%',
        padding: "".concat(extras.spacing.byStep(2), "px ").concat(extras.spacing.byStep(1), "px ").concat(extras.spacing.byStep(2), "px ").concat(extras.spacing.byStep(7), "px"),
        '& + .flag-dropdown .selected-flag': {
          padding: "0 ".concat(extras.spacing.byStep(1), "px"),
          '& .arrow': {
            left: 29
          }
        }
      }
    },
    standardInput: {
      '&.form-control.form-control': {
        font: 'inherit',
        background: palette.background["default"],
        border: 'none',
        borderBottom: "1px solid ".concat(palette.grey[500]),
        borderRadius: 0,
        outline: 'none',
        padding: "".concat(extras.spacing.byStep(1), "px ").concat(extras.spacing.byStep(1), "px ").concat(extras.spacing.byStep(1), "px ").concat(extras.spacing.byStep(7), "px"),
        '&:focus': {
          boxShadow: 'none',
          borderBottom: "2px solid ".concat(palette.primary[700])
        }
      }
    },
    disabledInput: {
      '&.form-control.form-control:disabled': {
        borderColor: palette.action.disabled,
        opacity: '0.5',
        '& + .flag-dropdown': {
          opacity: '0.5'
        }
      }
    },
    errorInput: {
      '&.form-control.form-control': {
        borderColor: palette.error.main,
        '&:focus': {
          boxShadow: 'none',
          borderColor: palette.error.main
        }
      }
    },
    dropdown: {
      '&.country-list.country-list.country-list': {
        width: 'inherit'
      },
      '& .search.search.search': {
        padding: extras.spacing.byStep(1),
        '& input#search-box': {
          width: '100%',
          marginLeft: 0,
          padding: extras.spacing.byStep(1)
        }
      }
    }
  };
};

var PhoneInput_PhoneInput = function PhoneInput(_ref2) {
  var _classnames;

  var classes = _ref2.classes,
      _ref2$error = _ref2.error,
      error = _ref2$error === void 0 ? false : _ref2$error,
      _ref2$disabled = _ref2.disabled,
      disabled = _ref2$disabled === void 0 ? false : _ref2$disabled,
      _ref2$fullWidth = _ref2.fullWidth,
      fullWidth = _ref2$fullWidth === void 0 ? false : _ref2$fullWidth,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'standard' : _ref2$variant,
      helperText = _ref2.helperText,
      label = _ref2.label,
      props = _objectWithoutProperties(_ref2, _excluded);

  var theme = Object(styles_["useTheme"])();
  var inputClass = classnames_default()(classes.input, (_classnames = {}, _defineProperty(_classnames, classes.standardInput, variant === 'standard'), _defineProperty(_classnames, classes.fullWidthInput, fullWidth), _defineProperty(_classnames, classes.disabledInput, disabled), _defineProperty(_classnames, classes.errorInput, error), _classnames));
  Object(external_react_["useEffect"])(function () {
    // $FlowFixMe
    document.getElementById('phone-form-control').setAttribute('dir', 'ltr');
  }, [theme.direction]);
  return /*#__PURE__*/external_react_["createElement"]("div", {
    className: classes.root
  }, variant === 'standard' && label && /*#__PURE__*/external_react_["createElement"](Typography_default.a, {
    display: "inline",
    color: "textSecondary",
    variant: "caption"
  }, label), /*#__PURE__*/external_react_["createElement"](external_react_phone_input_2_default.a, _extends({
    inputProps: {
      id: 'phone-form-control'
    },
    inputClass: inputClass,
    dropdownClass: classes.dropdown,
    disabled: disabled
  }, props)), !!helperText && /*#__PURE__*/external_react_["createElement"](FormHelperText_default.a, {
    error: error
  }, helperText));
};

/* harmony default export */ var src_PhoneInput_PhoneInput = (Object(styles_["withStyles"])(styles)(PhoneInput_PhoneInput));
// CONCATENATED MODULE: ./src/PhoneInput/index.js

/* harmony default export */ var src_PhoneInput = __webpack_exports__["default"] = (src_PhoneInput_PhoneInput);

/***/ }),

/***/ 5:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ })

/******/ });
});